import { useContext } from 'react';
import { ProfileCompletionContext } from '../../Providers';

export const useProfileCompletion = () => {
  const { completion } = useContext(ProfileCompletionContext);

  return { completion };
}
